<template>
  <div v-on:click="$emit('click')" class="col-6 col-sm-6 col-md-4 col-xl-3 col-catg">
    <div class="catg-block d-flex align-items-center justify-content-between cursor-default">
      <p>{{ category.title }}</p>
      <span class="span-num d-flex align-items-center justify-content-center">
        {{ category.count }}
      </span>
    </div><!-- ends catg-block -->
  </div>
</template>

<script>
// import { mapState } from 'vuex';

export default {
  name: 'category-item',
  props: ['category'],
};
</script>

<style scoped>
.cursor-default{
  cursor: default !important;
}
</style>
